/*
 * @Author: zhouwei
 * @Date: 2019-10-18 13:58:32
 * @Last Modified by: zhouwei
 * @Last Modified time: 2020-04-07 18:46:30
 * @Desc: 统计数据/销售参与统计
*/
<template>
  <div class="sale">
    <div
      v-if="saleCensus && saleCensus.length > 0"
      style="width: 100%; display: flex;"
      class="sale-list"
    >
      <div
        v-for="(item,index) in saleCensus"
        :key="index"
        class="sale-item"
      >
        <p class="txt">
          <span class="txt-line"></span>{{ item.index }}.分享{{ item.type }} 《{{ item.title }}》
        </p>
        <mk-pie
          v-if="item.allSales !== 0"
          :data="item.data"
          :options="item.options"
          :tooltip="tooltip"
          class="mk-pie"
        ></mk-pie>
        <div
          v-else
          class="no-data mk-pie"
        >
          <div class="no-data-img">
            <img
              src="@/assets/images/no-data.png"
              class="img"
            >
          </div>
          <div class="no-data-txt">
            暂无数据
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      class="no-data"
    >
      <div class="no-data-img">
        <img
          src="@/assets/images/no-data.png"
          class="img"
        >
      </div>
      <div class="no-data-txt">
        暂无数据
      </div>
    </div>
    <!--  员工执行情况 -->
    <sale-execute-condition />
    <!-- 原销售参与情况 -->
    <!-- <sale-clue
      :sale-data="salePartake"
      @load="saleLoad"
    >
    </sale-clue> -->
  </div>
</template>
<script>
import saleExecuteCondition from '../sale-execute-condition'
// import saleClue from '../../../../statistical-data/source-data/sale-clue.vue'
import { BIZAPIS } from '@api'
export default {
  components: {
    saleExecuteCondition
  },
  props: {
    taskList: {
      type: [Array, Object],
      default () {
        return []
      }
    }
  },
  data () {
    return {
      salePartake: [], // 销售参与数据
      saleCensus: [],
      tooltip: [
        'item*percent*count',
        (item, percent, count) => {
          percent = (percent * 100).toFixed(2) + '%'
          return {
            name: item,
            value: '数量:' + count + ',占比:' + percent
          }
        }
      ],
      page: 1, // 第几页
      isEnd: false // 是否没有下一页数据
    }
  },
  created () {
    this.getData()
    // this.getSalePartake()
  },
  methods: {
    sort (arr) {
      // 数组升序
      var min
      for (var i = 0; i < arr.length; i++) {
        for (var j = i; j < arr.length; j++) {
          if (arr[i].index > arr[j].index) {
            min = arr[j]
            arr[j] = arr[i]
            arr[i] = min
          }
        }
      }
    },
    async getData () {
      if (this.taskList instanceof Array) {
        this.taskList.forEach((item, index) => {
          let id = item._id
          let title = item.showName
          let type = item.materialType
          let status = Number(item.status)
          let typeTxt = ''
          if (type === 'article') {
            typeTxt = '文章'
          } else if (type === 'form') {
            typeTxt = '表单'
          } else if (type === 'friend') {
            typeTxt = '朋友圈'
          }
          if (status === 1 && Number(this.$route.query.status) === 2) {
            // this.scensusSales(id, title, typeTxt, item.index)
            this.scensusSales(id, title, typeTxt, index + 1)
          } else if (status === 2 && Number(this.$route.query.status) === 3) {
            // this.scensusSales(id, title, typeTxt, item.index)
            this.scensusSales(id, title, typeTxt, index + 1)
          }
        })
      }
    },
    async scensusSales (taskID, title, type, index) {
      // 参与销售统计
      const res = await BIZAPIS.StatisticsApi.timingPlanReleaseTaskSalesStatisticsGet(
        {
          planID: this.$route.query.id,
          taskID: taskID
        }
      )
      if (res.success) {
        let obj = {
          id: taskID,
          index: index,
          title: title,
          type: type,
          data: [
            {
              item: '已完成',
              count: res.data.FinishedSales
            },
            {
              item: '未完成',
              count: res.data.UnfinishedSales
            },
            {
              item: '未读',
              count: res.data.UnreadSales
            }
          ],
          allSales: res.data.TotalSales,
          options: {
            chart: {
              width: 320,
              height: 320,
              padding: ['100', '105']
            },
            coord: {
              innerRadius: 0.8
            },
            html: {
              text: '执行员工',
              subtext: res.data.TotalSales,
              unit: '人'
            },
            max: 10
          }
        }
        this.saleCensus.push(obj)
        this.sort(this.saleCensus)
      }
    },
    async getSalePartake () {
      // 销售参与情况
      const res = await BIZAPIS.StatisticsApi.timingPlanSalesStatisticsGet({
        planId: this.$route.query.id,
        page: this.page,
        pageSize: 7
      })
      if (res.success) {
        let data = res.data.data
        if (data && data.length < 7) {
          this.isEnd = true
          let arr = this.salePartake.concat(data)
          this.salePartake = arr
        } else {
          let arr = this.salePartake.concat(data)
          this.salePartake = arr
        }
      }
    },
    saleLoad () {
      // 无线滚动滚动到底部事件
      if (!this.isEnd) {
        this.page++
        this.getSalePartake()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.sale {
  display: flex;
  justify-content: space-between;

  .no-data {
    display: flex;
    flex-direction: column;
    align-items: center;
    // padding-bottom: 100px;
    padding: 50px 0;

    .no-data-img {
      width: 80px;
      height: 59px;

      .img {
        width: 100%;
        height: 100%;
      }
    }

    .no-data-txt {
      font-size: 14px;
      margin-top: 12px;
      color: #bfbfbf;
    }
  }

  .sale-list {
    flex-wrap: wrap;
  }

  .sale-item {
    max-width: 340px;
    height: 367px;
    border: 1px solid #e8e8e8;
    flex: 1;
    margin-top: 20px;
    margin-right: 18px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .txt {
      color: #262626;
      text-align: justify;
      text-justify: newspaper;
      word-break: break-all;
      box-sizing: border-box;
      line-height: 18px;
      font-size: 13px;
      padding: 11px 16px;
      border-bottom: 1px solid #e8e8e8;
      width: 100%;

      .txt-line {
        display: inline-block;
        width: 3px;
        height: 12px;
        background-color: #009cff;
        border-radius: 1px;
        margin-right: 5px;
        position: relative;
        top: 2px;
      }
    }
  }
}
</style>
